const {
    RA_ZERO_QUESTION_ID,
} = require('../../raConstants/contactCenter/zeroQuestionCodes');

const zeroQuestionPresent = (immQuestions, readOnly = false) =>
    __CONTACT_CENTER__ &&
    !!immQuestions &&
    !!immQuestions.get(RA_ZERO_QUESTION_ID) &&
    !readOnly;

const zeroQuestionWasAnswered = immQuestions =>
    !!immQuestions && !immQuestions.get(RA_ZERO_QUESTION_ID);

module.exports = {
    zeroQuestionPresent,
    zeroQuestionWasAnswered,
};
